import { useDispatch } from 'react-redux';
import { Axios, useState, toast, FaEyeSlash } from '../../common/common';
// import { Capitalize } from '../../common/CommonFunctions';
// import { Removehyphen } from '../../common/CommonFunctions.js';
import { useErrorContext } from '../../context/ErrorContext.js';
import Validation from '../../validation/Authentication/Validation.js';
import { loginSuccess } from '../../redux/slices/userSlice.js';
import useNavigation from '../../common/useNavigation.js';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';


const MidRegister = (country) => {

    const dispatch = useDispatch();
    const { navigateOTP,navigateEmailOTP } = useNavigation();
    const { setValidationError, clearAllErrors } = useErrorContext();
    const { validateRegistrationForm } = Validation;
    const [values, setValue] = useState({
        fullName: "",
        emailAddress: "",
        mobileNumber: "",
        passWord: "",
    });
    const [isLoading, setisLoading] = useState(false);
    const [isDisabled, setisDisabled] = useState(false);
    const [type, setType] = useState('password');
    const [icon, setIcon] = useState(FaEyeSlash);
    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateRegistrationForm(values, country);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };
    const handleChange = e => {
        const { name, value } = e.target;
        setValue(prev => ({ ...prev, [name]: value }));
        if (Object.keys(validateAndSetErrors(values)).length === 0) clearAllErrors(); // Clear errors if valid
    };

    const handleSubmit = e => {
        e.preventDefault();
        const validationErrors = validateAndSetErrors(values);
        if (Object.keys(validationErrors).length === 0) {
            clearAllErrors();
            register(); // Assuming checkLogin() is a function to handle actual login logic
        }
    };
    const register = () => {

        if (country === 'India') {
            const { fullName, emailAddress, mobileNumber, passWord } = values;
            const data = { fullName, mobileNumber, emailAddress, passWord, country_flag: 1 };

            if (!fullName || !mobileNumber || !passWord) {
                showToast('Please fill all required fields', 'error');
                return;
            }
            StartLoading(setisLoading, setisDisabled);
            Axios.post(`${process.env.REACT_APP_API_URL}/api/register`, { data }, { withCredentials: true, credentials: 'include' })
                .then(handleRegistrationResponse)
                .catch(handleRegistrationError);
        }
        else if (country === 'Other') {
            const { fullName, emailAddress, passWord } = values;
            const data = { fullName, emailAddress, passWord, country_flag: 2 };

            if (!fullName || !emailAddress || !passWord) {
                showToast('Please fill all required fields', 'error');
                return;
            }
            StartLoading(setisLoading, setisDisabled);
            Axios.post(`${process.env.REACT_APP_API_URL}/api/register`, { data }, { withCredentials: true, credentials: 'include' })
                .then(handleRegistrationResponse)
                .catch(handleRegistrationError);
        }
    };
    const handleRegistrationResponse = async (res) => {
        StopLoading(setisLoading, setisDisabled);
        const result = res.data;
        // console.log({ result: result });
        if (result.success === 1) {
            handleSuccessfulRegistration(result);
           
        } else {
            showToast(result.message, 'error');
        }
        resetLoadingState();
    };
    const handleRegistrationError = (err) => {
        // console.error(err);
        showToast(err.message, 'error');
        resetLoadingState();
    };
    const handleSuccessfulRegistration = (result) => {
        // console.log('country is ' + country);
        const { message } = result;
        dispatch(loginSuccess(result));
        showToast(message, 'success');
        clearForm();
        if (country === 'India') {
            setTimeout(() => {
                navigateOTP();
            }, 3000);
        }
        else if (country === 'Other') {
            console.log('inside other ');
            setTimeout(() => {
                navigateEmailOTP();
            }, 3000);
        }


    };
    const showToast = (message, type) => {
        const options = {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
        };

        if (type === 'success') {
            toast.success(message, options);
        } else {
            toast.error(message, options);
        }
    };
    const clearForm = () => {
        values.fullName = "";
        values.emailAddress = "";
        values.mobileNumber = "";
        values.passWord = "";
    };

    const resetLoadingState = () => {
        setisLoading(false);
        setisDisabled(false);
    };

    const handleToggle = () => {
        if (type === 'password') { setType('text'); }
        else { setType('password'); }
    }


    return { handleChange, handleSubmit, useErrorContext, values, type, icon, handleToggle, isLoading, isDisabled }
}

export default MidRegister